import { AuthorizationPolicy } from '@microsoft/microsoft-graph-types-beta';
import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'authorizationPolicy';

export interface State extends Status {
    data: AuthorizationPolicy;
}

export const initialState: State = {
    data: null,
    ...initialStatus,
};

export const reducer = createReducer(
    initialState,

    on(actions.loadAuthorizationPolicySuccess, (state, action) => ({
        ...state,
        data: action.policy,
        error: false,
        loaded: true,
    })),
    on(actions.loadAuthorizationPolicyFailure, (state, { error }) => ({
        ...state,
        error,
        loaded: false,
    })),

    on(actions.updateAuthorizationPolicy, (state, action) => ({
        ...state,
        updating: true,
        error: null,
    })),

    on(actions.updateAuthorizationPolicySuccess, (state, action) => ({
        ...state,
        data: { ...action.policy },
        updating: false,
        error: false,
    })),

    on(actions.updateAuthorizationPolicyFailure, (state, { error }) => ({
        ...state,
        error,
        updating: false,
    })),
);

export const selectPolicy = (state: State) => state.data;
export const selectError = (state: State) => state.error;
